<template>
  <div class="onboarding-signup-step-identity">
    <VeeForm @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.IDENTITY.@TITLE")) }}
          </h2>

          <Identity v-model:firstname="form.firstname" v-model:lastname="form.lastname" :i-model="ISignup" />
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { ISignup } from "@core/models";
  import { useSignup } from "@etab/composables";
  import { ref, onMounted } from "vue";
  import { useTransition } from "@core/composables";

  import Identity from "@etab/components/onboarding/signup/Identity.component.vue";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();

  const form = ref({ firstname: "", lastname: "" });

  // Methods
  const onSubmit = async function () {
    const data = {
      [ISignup.firstname]: form.value.firstname,
      [ISignup.lastname]: form.value.lastname,
    };
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step8_identity",
    });
    signupStore[ACTION_SIGNUP_UPDATE](data);
    $_nextStep();
  };

  onMounted(() => {
    form.value.firstname = signupStore[GETTER_SIGNUP_GET][ISignup.firstname] || "";
    form.value.lastname = signupStore[GETTER_SIGNUP_GET][ISignup.lastname] || "";
  });
</script>
